import type { PropsWithChildren } from 'react'
import React from 'react'
import Caption from '../Typography/Caption'

interface Props extends PropsWithChildren {
  className?: string
}

function PriceRowCaption(props: Props) {
  const {
    children,
    className,
  } = props

  return <Caption
    className={className}
    variant="medium"
    weight="normal"
    colour="neutral-three"
  >
    {children}
  </Caption>
}

export default PriceRowCaption
